import { IDefineCommand } from 'core-ts-types';
import { AuthenticationQueryModel } from '../queries/authentication_query_model';
import { UserActivityActivationQuery } from '../queries/user_activity_activation_query';
angular
  .module('data-ng-authentication')
  .factory(
    'activateUserActivityCommand',
    (
      defineCommand: IDefineCommand,
      userActivity: any,
      ngAuthenticationQueryModel: AuthenticationQueryModel,
      ngUserActivityActivationQuery: UserActivityActivationQuery
    ) =>
      defineCommand('activateUserActivityCommand', (deferred) => {
        if (!ngAuthenticationQueryModel.isAccountValid()) {
          deferred.reject('account model is not valid');
          return;
        }

        if (!ngAuthenticationQueryModel.isMemberValid()) {
          deferred.reject('login config model is not valid');
          return;
        }

        const uaActivationQuery = ngUserActivityActivationQuery.run();

        try {
          userActivity.initialize(uaActivationQuery.about);
          userActivity.registerPerson(
            uaActivationQuery.personRegistration.id,
            uaActivationQuery.personRegistration.email,
            uaActivationQuery.personRegistration.properties
          );
        } catch (e) {
          // ??
        }

        deferred.resolve();
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/data-ng-authentication/src/commands/activate_user_activity_command.ts